// extracted by mini-css-extract-plugin
export default {"iconWrapper":"XSap+","icon":"Y81iy"};